import { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import '../style2.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ScrolltoTop from '../components/ScrolltoTop';
import UtmUpdate from '../components/WhatsAppUTMLinkUpdater';


const FAQSection = ({ title, faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    
    <div className="faq-section">
      <UtmUpdate/>
      <h2 className="faq-section-title">{title}</h2>
      <div className="faq-items">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button
              onClick={() => toggleFAQ(index)}
              className="faq-question"
            >
              <span>{faq.question}</span>
              {openIndex === index ? <FaMinus /> : <FaPlus />}
            </button>
            {openIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

function CruiseFAQs() {
  const sections = [
    {
      title: 'Planning',
      faqs: [
        {
          question: 'What destinations can I take a cruise to?',
          answer:
            'Simply put, almost anywhere in the world. Sail to exciting ports in Alaska, Asia, Australia/New Zealand, the Bahamas, Bermuda, Canada/New England, the Caribbean, Europe, Hawaii, Mexico, the Pacific Northwest, Panama Canal, South America, and Transatlantic.\nCheck our cruise calendar for more information on the destinations.'
        },
        { question: 'Will I get sea sick?', answer: "In today’s day and age all cruise liners are fitted with modern stabilizing systems that correct roll, pitch and yaw, so it is highly unlikely that you will experience motion sickness. In any event, weather predictions are taken into account and the ship will not sail into bad weather knowingly." },
        { question: 'Is a cruise vacation affordable?', answer: "Yes. A cruise vacation is highly affordable! There are cruise vacations to suit every budget. Where else will you get cruise transportation, accommodation, most meals, activities and entertainment included in the price you pay. No surprises here. The extra you spend maybe on your alcoholic and beverage purchases and on your shore excursions." },
        { question: 'Will I feel confined on the ship or get bored?', answer: "No way! Your cruise ship is a floating resort and with so many things to do and explore, it will probably take you a couple of days to get familiar with your surroundings. The cruise ship is huge and there is plenty of space.So much to do and so little time is a refrain that is commonly heard on board a cruise ship! Active enthusiasts will find loads of activities to keep them busy, be it jogging, gymming, swimming, and even practicing one’s putt on the mini golf course. For the more relaxed ones, a leisurely spa treatment, a book by the pool and a stretch in the sauna are only some of the options available." },
        { question: 'What is the policy for infants and pregnant women?', answer: "Anyone who is fit and does not suffer from any communicable disease can cruise. However there are certain exceptions. Pregnant women should not have entered or will enter into the 24th week of pregnancy while on the cruise are considered high risk. No guest who is under 21 years can be booked unless accompanied by an adult 21 years or older. This may be waived if parents are travelling in adjacent cabin. In the case of unaccompanied minor sailing with grandparents or other relative or adult, a notarized letter of consent by at least one parent/legal guardian stipulating certain conditions is to be presented. If this is not complied with, boarding will be denied.Generally infants have to be at least six months old on the first day of the cruise, however on some Trans Atlantic, South America and Hawaii cruises, the infant must be at least twelve months old on the first day of the cruise. It is recommended that you check the rules prior to booking, as non compliance may result in denied boarding." },
        { question: 'What are the passport and visa requirements for my cruise?', answer: '' },
        { question: 'What are the different types of accommodation available on board?', answer: '' },
        { question: 'I am travelling alone. Are there any special prices for a single person in a cabin?', answer: '' },
        { question: 'How do I pay for onboard purchases?', answer: '' },
        { question: 'What are shore excursions and how do I book them?', answer: '' },
        { question: 'What facilities do you have for guests with special needs?', answer: '' },
      ]
    },
    {
      title: 'Reservation',
      faqs: [
        {
          question: 'What destinations can I take a cruise to?',
          answer:
            "Once you have chosen your cruise, contact your travel agent or get in touch with us at TIRUN to make your reservation. In order to make the reservation you will need to give your names as per your passport, pay a deposit amount as stipulated depending on the length and duration of your cruise. Once the deposit has been paid, you will receive a written confirmation. Please visit our section Terms and Conditions for complete details on payment and cancellation terms.Terms and Conditions Final payment of the balance must be received at our office at least 60 days prior to the sailing date for the cruise.Note: “Holiday” sailings (sailings over Thanksgiving, Christmas & New Year), require final payment 90 days prior to the sailing date for the cruise."
        },
        { question: 'How do I pay - what are the different modes?', answer: '' },
        { question: 'What is included in my cruise price?', answer: '' },
        { question: 'What is not included in my cruise price?', answer: '' },
        { question: 'Do you have special prices for children and infants?', answer: '' },
        { question: 'Is it possible to get a senior citizen special price?', answer: '' },
        { question: 'Is it possible to take a partial cruise?', answer: '' },
        { question: 'What if I have a minor travelling with me, but am not the parent or guardian?', answer: '' },
        { question: 'I already have a travel insurance. Should I take an extra insurance coverage for my cruise?', answer: '' },
      ]
    },
    {
      title: 'Preparing for the Cruise',
      faqs: [
        { question: 'When can I board the ship?', answer: 'It is advisable to arrive at the pier at least two–three hours before the scheduled departure time...' },
        { question: 'How do I get to the ship from the airport? Can I get a transfer?', answer: '' },
        { question: 'What to pack?', answer: '' },
        { question: 'Are there any restrictions on what I cannot bring onboard?', answer: '' },
        { question: 'Why should I use the online check-in process?', answer: '' },
        { question: 'Can I bring my own liquor on board?', answer: '' },
        { question: 'Can my friends and family come and visit me on the ship?', answer: '' },
      ]
    },
    {
      title: 'Onboard the Cruise Ship',
      faqs: [
        { question: 'Are there Baby sitters on board?', answer: "Royal Caribbean International’s Sitters at Sea program has been discontinued beginning on September 30th, 2018..." },
        { question: 'Does the ship provide high chairs and baby strollers on board?', answer: '' },
        { question: 'Are there ATM machines on board?', answer: '' },
        { question: 'What about special dietary needs? Will I be able to get Indian vegetarian meals?', answer: '' },
        { question: 'Where can I dine onboard besides the dining room?', answer: '' },
        { question: 'What are the smoking policies onboard?', answer: '' },
        { question: 'What about room service?', answer: '' },
        { question: 'What activities are there onboard for children and teenagers?', answer: '' },
        { question: 'Can I get internet access on board?', answer: '' },
        { question: 'What happens if I fall ill while on board the cruise?', answer: '' },
        { question: 'What are the tipping guidelines?', answer: '' },
        { question: 'During the cruise what documents do I need to carry to get back onto the ship after ashore excursion?', answer: '' },
      ]
    },
    {
      title: 'Customer Support by Tirun',
      faqs: [
        { question: 'Email', answer: 'In case you have a question that remains unanswered, please get in touch with us and we will be happy to help you out.\nWrite to us at cruise@tirun.com or Request a Call Back.' },
        { question: 'Toll Free Number', answer: '' },
      ]
    },
  ];

  return (

    <>
    <Navbar/>

    <div className="header">
                        <div className="offer-alert">
                            <div>
                                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                            </div>
                            <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
                        </div>
                        </div>

    <div className="faq-container">
      <h1 className="faq-title2">FAQs</h1>
      {sections.map((section, index) => (
        <FAQSection key={index} title={section.title} faqs={section.faqs} />
      ))}
    </div>

   <ScrolltoTop/>
    <Footer/>
    </>
  );
}



export default CruiseFAQs ;